import React from "react"
import Header4 from "./../Common/Header4"
import Footer from "./../Common/Footer"
import Banner from "./../Elements/Banner"
import WhatWeDo6 from "./../Elements/WhatWeDo6"
import Services6 from "./../Elements/Services6"
import Services7 from "./../Elements/Services7"
import ClientsLogo1 from "./../Elements/ClientsLogo1"

var bnrimg = require("./../../images/banner/6.jpg")

class Service1 extends React.Component {
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="SERVICES"
            pagename="Services"
            description="We offer complete design services that blend creativity and precision to transform your space. From concept to completion, we create timeless, functional, and beautiful environments."
            bgimage={bnrimg}
          />
          {/* <Services6 /> */}
          <WhatWeDo6 />
          {/* <Services7 /> */}
          {/* <ClientsLogo1 /> */}
        </div>
        <Footer />
      </>
    )
  }
}

export default Service1
